import { Component } from '@angular/core';
import { BroadcastService, BroadcastEventModel } from '@cv-invision/core';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { SetIsImportingOrder, SetIflagSoftDelete } from '../state/action/import.action';
import { StateModel, IMPORTMSG } from '../model/import-confirmation.model';

export const CONFIRM_ORDER_IMPORT = 'confirmOrderImport';
@Component({
	selector: 'cv-confirmation-import-modal',
	templateUrl: './confirmation-import-modal.component.html',
	styleUrls: ['./confirmation-import-modal.component.scss']
})
export class ConfirmationImportModalComponent {
	orderData: any;
	isOpen: boolean;
	canImport: boolean;
	confirmationMsg: string;
	confirmationNoDelete: string;
	ischeckedDuplicate: boolean;
	constructor(
		private broadcastService: BroadcastService,
		private router: Router,
		private store: Store
	) {
		this.ischeckedDuplicate = true;
		this.store.dispatch(new SetIflagSoftDelete(this.ischeckedDuplicate));

		this.registerApproveListener();
	}

	/**
	 * Register Lister to Show/Hide modal
	 *
	 */
	private registerApproveListener(): void {
		this.broadcastService.on(CONFIRM_ORDER_IMPORT, (broadcast: BroadcastEventModel) => {
			this.store.dispatch(new SetIsImportingOrder(null));
			this.orderData = broadcast.event.orderData;
			this.setModalData(broadcast.event.totalCount);
		});
	}

	/**
	 * set all the valida data for display te modal confirmation
	 */
	setModalData(count: number): void {
		this.canImport = this.displayImportBtn();
		this.confirmationNoDelete = IMPORTMSG.CANNOTIMPORT;
		this.confirmationMsg = count > 1 ? IMPORTMSG.CANDELETEMUILTIPLES : IMPORTMSG.CANDELETE;
		this.isOpen = true;
	}

	/**
	 * go to the order
	 */
	openOrder(): void {
		this.router.navigate([`/intelligence/quality/overview`, this.orderData.id]);
	}

	/**
	 * set state for import a order
	 */
	importOrder(): void {
		this.store.dispatch(new SetIflagSoftDelete(true));
		this.store.dispatch(new SetIsImportingOrder(true));
		this.closeImporBox();
	}

	/**
	 * set duplicate flag
	 */
	displayImportBtn(): boolean {
		if (
			this.orderData &&
			(this.orderData.stateEnum === StateModel.Approved || this.orderData.revised)
		) {
			return false;
		}
		return true;
	}

	/**
	 * close box
	 */
	closeImporBox(): void {
		this.store.dispatch(new SetIsImportingOrder(false));
		this.isOpen = false;
	}
}
